<template>
  <div id="offices">
    <span class="text bold-strong size-18">Tenemos más de una sede</span>
    <span class="text bold center size-12 margin-bot-30">
      Por favor selecciona la sede en la que te encuentres para
      calificarnos
    </span>
    <div class="cont-options">
      <div
        :key="index + item.id"
        @click="getSurvey(item)"
        class="white-rectangle"
        v-for="(item, index) in offices"
      >
        <div class="black-circle">
          <img :src="item.image" alt class="img-source" v-if="item.image" />
          <img alt class="new-icon" src="@/assets/images/icons/restaurante.svg" v-else />
        </div>
        <!-- <div class="boundry-text"></div> -->
        <span class="title-text-menu">{{ item.displayName }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import whiteLabelTypes from '@/store/types/whiteLabel';
import globalTypes from '@/store/types/global';
export default {
  data () {
    return {
      options: null,
      offices: []
    };
  },
  mounted () {
    this.getOptions();
    this.getOffices();
    if (this.params.bannerActiveMenuDigital === 1) {
      this.$store.commit('whiteLabel:setMenuIdBanner', 'Offices');
    }
  },
  methods: {
    formOrMenu (num) {
      if (num === 2) {
        this.$emit('activeView', 2);
      } else {
        if (this.params.multiMenu) {
          this.$emit('activeView', 6);
        } else {
          this.$emit('activeView', 4);
        }
      }
      if (num === 9) {
        this.$emit('activeView', 9);
      }
    },
    openLink (item) {
      if (item[0].type === 'url') {
        window.open(item[0].image);
      } else if (item[0].type === 'image') {
        this.$emit('activeView', 5);
        this.$emit('image', item);
      }
    },
    getSurvey (item) {
      const url = item.redirectUrl.split('/');
      const redirect = `${url[0]}//${url[2]}/pollQR/?vendor=${item.vendorId}`;
      window.open(redirect, '_blank');
    },
    getOptions () {
      this.$http
        .get('menudigital/param/' + this.params.vendorId)
        .then(({ data }) => {
          this.options = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getOffices () {
      this.$store
        .dispatch({ type: 'whiteLabel:branch', data: { url: this.vendorUrl } })
        .then((response) => {
          this.offices = response;
        })
        .catch(() => {
          console.log('Error al cargar Branch');
        });
    }
  },
  computed: {
    ...mapGetters({
      vendorUrl: globalTypes.getters.vendorUrl,
      branch: whiteLabelTypes.getters.branch
    })
  }
};
</script>
<style lang="scss">
@font-face {
  font-family: sourceSansPro;
  src: url(../../assets/fonts/SourceSans/SourceSansPro-Regular.ttf);
}
#offices {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .cont-options {
    width: 100%;
    display: flex;
    flex-flow: wrap;
    justify-content: center;
    margin-top: 20px;
    .white-rectangle {
      display: flex;
      position: relative;
      max-width: 150px;
      justify-content: center;
      width: 100%;
      height: 50px;
      background-color: #fff;
      box-shadow: 1px 1px 11px 2px rgba(0, 0, 0, 0.75);
      border-radius: 35px 5px 5px 35px;
      align-items: center;
      margin: 10px 10px 20px 10px;
      padding-left: 42px;
      padding-right: 4px;
      cursor: pointer;
    }
    .black-circle {
      display: flex;
      justify-content: center;
      height: 50px;
      min-height: 50px;
      min-width: 50px;
      width: 50px;
      background-color: #000000;
      border-radius: 100%;
      box-shadow: 1px 3px 6px #00000069;
      position: absolute;
      left: -10px;
      top: 0;
    }
    .title-text-menu {
      text-align: center;
      color: black;
      font-size: 12px;
      font-family: "sourceSansPro";
      text-transform: uppercase;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .new-icon {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 40px;
      height: 40px;
    }
    .img-source {
      height: 43px;
      width: 43px;
      border-radius: 100%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .text {
    &.ellipsis {
      width: 120px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  // @media screen and (max-width: 800px) and (min-width: 420px) {
  //   .white-rectangle {
  //     zoom: 0.7;
  //   }
  // }
  // @media screen and (max-width: 620px) and (min-width: 300px) {
  //   .white-rectangle {
  //     zoom: 0.4;
  //   }
  // }
  // @media screen and (max-width: 312px) and (min-width: 200px) {
  //   .white-rectangle {
  //     zoom: 0.3;
  //   }
  //   #menuDigital .text.size-12 {
  //     font-size: 10px;
  //   }
  // }
}
</style>
